import { useState, useEffect } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';

import { isCurrentAccountOwner } from '../utils/BlockchainAPI';

import DynaNavLoginDropdown from './DynaNavLoginDropdown';


const DynaNav = () => {
  const [isOwner, setIsOwner] = useState(false);

  useEffect(() => {
    const fetchOwnerStatus = async () => {
      console.log("[DynaNav] Fetching owner status...");
      try {
        const isOwnerVal = await isCurrentAccountOwner();
        setIsOwner(isOwnerVal);
      } catch {
        setIsOwner(false);
      }
    }

    fetchOwnerStatus();
  }, []);


  return (
    // <Navbar bg="light" expand="lg" sticky="top">
    <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand href="/" className="dyna">DynaStripes</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/mint">Mint!</Nav.Link>
            <Nav.Link href="/gallery">Gallery</Nav.Link>
            <Nav.Link href="/howto">How to</Nav.Link>
            <Nav.Link href="/about">About</Nav.Link>
            <Nav.Link href="/feedback">Feedback</Nav.Link>
            {isOwner === true ? <Nav.Link href="/admin">Admin</Nav.Link> : null}
          </Nav>
          <Nav>
            <DynaNavLoginDropdown />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default DynaNav;